export default "assets/images/chatbox-5f66beef.png";